import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faFilter } from '@fortawesome/free-solid-svg-icons';
import { Category } from '../../types/Category';
import { Brands } from '../../types/Brands';
import buttonListViewSelected from '../../assets/button_list_view_selected.svg';
import buttonListView from '../../assets/button_list_view.svg';
import buttonThumbnailViewSelected from '../../assets/button_thumbnail_view_selected.svg';
import buttonThumbnailView from '../../assets/button_thumbnail_view.svg';
import './ProductFilters.scss'; // Create this SCSS file for mobile styles

interface ProductFiltersProps {
  categoryId: string | null;
  brandId: string | null;
  sortOrder: string;
  categories: Category[]; 
  brands: Brands[]; 
  onCategoryChange: (categoryId: string | null) => void;
  onBrandChange: (brandId: string | null) => void;
  onSortChange: (sortOrder: string) => void;
  viewMode: 'grid' | 'list';
  onViewModeChange: (mode: 'grid' | 'list') => void;
}

const ProductFilters: React.FC<ProductFiltersProps> = ({
  categoryId,
  brandId,
  sortOrder,
  categories,
  brands,
  onCategoryChange,
  onBrandChange,
  onSortChange,
  viewMode,
  onViewModeChange,
}) => {
  const [isMobile, setIsMobile] = useState(false);
  const [showFilters, setShowFilters] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1100);
    };

    handleResize(); // Set initial value
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const CategoryList = ({ categories, selectedId, onSelect, level = 0 }) => (
    <ul className="filter-list-inside">
      {categories.map((category) => (
        <li key={category.id} style={{ paddingLeft: `${level * 16}px` }}>
          <label className="checkbox-style">
            <input
              type="checkbox"
              checked={selectedId === category.id}
              onChange={() =>
                selectedId === category.id
                  ? onSelect(null) // deselect
                  : onSelect(category.id) // select new
              }
            />
            <span className="custom-checkbox" />
            {category.name}
          </label>
  
          {category.children && category.children.length > 0 && (
            <CategoryList
              categories={category.children}
              selectedId={selectedId}
              onSelect={onSelect}
              level={level + 1}
            />
          )}
        </li>
      ))}
    </ul>
  );

  const toggleFilters = () => {
    setShowFilters(!showFilters);
  };

  const toggleView = () => {
    if(viewMode=='list'){
        onViewModeChange('grid');
    }else{
        onViewModeChange('list');
    }
  }
  
  const renderDesktopFilters = () => (
    <>
      {/* CATEGORY FILTER */}
      <div className="filter-group">
        <h4>Κατηγορία</h4>
        <ul className='filter-list'>
            <CategoryList
                categories={categories}
                selectedId={categoryId}
                onSelect={onCategoryChange}
                />
        </ul>
      </div>
  
      {/* BRAND FILTER */}
      <div className="filter-group">
        <h4>Μάρκα</h4>
        <ul className="filter-list">
        {brands.map((brand) => (
            <li key={brand.id}>
            <label className="checkbox-style">
                <input
                type="checkbox"
                checked={brandId === brand.id}
                onChange={() => {
                    if (brandId === brand.id) {
                    onBrandChange(null);
                    } else {
                    onBrandChange(brand.id);
                    }
                }}
                />
                <span className="custom-checkbox" />
                {brand.name}
            </label>
            </li>
        ))}
        </ul>

      </div>
    </>
  );
  
  

  const renderMobileFilters = () => (
    <>
      <button className="mobile-filter-button" onClick={toggleFilters}>
        <span>Filters</span>
        <FontAwesomeIcon icon={faFilter} />
      </button>

      {showFilters && (
        <div className="mobile-filters-dropdown">
          <div className="filter-group">
            <label>Category</label>
            <select
              value={categoryId || ''}
              onChange={(e) => {
                onCategoryChange(e.target.value || null);
                setShowFilters(false);
              }}
            >
              <option value="">All Categories</option>
              {categories.map((category) => (
                <option key={category.id} value={category.id}>
                  {category.name}
                </option>
              ))}
            </select>
          </div>

          <div className="filter-group">
            <label>Brand</label>
            <select
              value={brandId || ''}
              onChange={(e) => {
                onBrandChange(e.target.value || null);
                setShowFilters(false);
              }}
            >
              <option value="">All Brands</option>
              {brands.map((brand) => (
                <option key={brand.id} value={brand.id}>
                  {brand.name}
                </option>
              ))}
            </select>
          </div>

          <div className="filter-group">
            <label>Sort By</label>
            <select
              value={sortOrder}
              onChange={(e) => {
                onSortChange(e.target.value);
                setShowFilters(false);
              }}
            >
              <option value="lowToHigh">Price Ascending</option>
              <option value="highToLow">Price Descending</option>
              <option value="aToZ">A-Z</option>
              <option value="zToA">Z-A</option>
            </select>
          </div>
        </div>
      )}
    </>
  );

  return (
    <>
      {isMobile ? renderMobileFilters() : renderDesktopFilters()}
    </>
  );
};

export default ProductFilters;